import { db } from '../database/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const WEEKLY_MENU_DOC = 'settings/weeklyShakeMenu';

/**
 * Get the weekly shake menu configuration
 * @returns {Promise<Object>} Weekly menu object with days as keys
 */
export const getWeeklyShakeMenu = async () => {
  try {
    const docRef = doc(db, WEEKLY_MENU_DOC);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      // Return default empty structure if not configured yet
      return {
        monday: { shake1: null, shake2: null },
        tuesday: { shake1: null, shake2: null },
        wednesday: { shake1: null, shake2: null },
        thursday: { shake1: null, shake2: null },
        friday: { shake1: null, shake2: null },
        saturday: { shake1: null, shake2: null },
        sunday: { shake1: null, shake2: null },
      };
    }
  } catch (error) {
    console.error('Error fetching weekly shake menu:', error);
    throw error;
  }
};

/**
 * Update the weekly shake menu configuration
 * @param {Object} menuData - Complete weekly menu object
 * @returns {Promise<void>}
 */
export const updateWeeklyShakeMenu = async (menuData) => {
  try {
    const docRef = doc(db, WEEKLY_MENU_DOC);
    await setDoc(docRef, {
      ...menuData,
      updatedAt: new Date().toISOString(),
    });
  } catch (error) {
    console.error('Error updating weekly shake menu:', error);
    throw error;
  }
};

/**
 * Get shakes for a specific day
 * @param {string} day - Day name in lowercase (e.g., 'monday')
 * @returns {Promise<Array>} Array of 2 shake objects
 */
export const getShakesForDay = async (day) => {
  try {
    const menu = await getWeeklyShakeMenu();
    const dayMenu = menu[day.toLowerCase()];
    
    if (!dayMenu) {
      return [];
    }
    
    // Return array of non-null shakes
    const shakes = [];
    if (dayMenu.shake1) shakes.push(dayMenu.shake1);
    if (dayMenu.shake2) shakes.push(dayMenu.shake2);
    
    return shakes;
  } catch (error) {
    console.error(`Error fetching shakes for ${day}:`, error);
    throw error;
  }
};

/**
 * Update shakes for a specific day
 * @param {string} day - Day name in lowercase
 * @param {Object} shake1 - First shake object {id, name}
 * @param {Object} shake2 - Second shake object {id, name}
 * @returns {Promise<void>}
 */
export const updateDayShakes = async (day, shake1, shake2) => {
  try {
    const menu = await getWeeklyShakeMenu();
    menu[day.toLowerCase()] = { shake1, shake2 };
    await updateWeeklyShakeMenu(menu);
  } catch (error) {
    console.error(`Error updating shakes for ${day}:`, error);
    throw error;
  }
};
